import { render, staticRenderFns } from "./InvoiceListArchived.vue?vue&type=template&id=a15fc232&"
import script from "./InvoiceListArchived.vue?vue&type=script&lang=js&"
export * from "./InvoiceListArchived.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceListArchived.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports